import { render } from "./TermsConditionsView.vue?vue&type=template&id=c5447ede"
import script from "./TermsConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsConditionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__